import API, { apiErrorMessage } from "../global/api";

// Add FbrSnroTesting
export const addFbrSnroTestingRequest = () => {
  return {
    type: "ADD_FBR_SNRO_TESTING_REQUEST",
  };
};
export const addFbrSnroTestingSuccess = (data) => {
  return {
    type: "ADD_FBR_SNRO_TESTING_SUCCESS",
    payload: data,
  };
};
export const addFbrSnroTestingError = (msg) => {
  return {
    type: "ADD_FBR_SNRO_TESTING_ERROR",
    payload: msg,
  };
};
export const addFbrSnroTesting = (
  data,
  handleVisible,
  handleDangerVisible,
) => {
  return (dispatch) => {
    dispatch(addFbrSnroTestingRequest());
    API.post(`/scenario/verify-scenario`, data)
      .then((res) => {
        let data1 = res.data;
        dispatch(addFbrSnroTestingSuccess(data1));
        handleVisible(res.data.message);
        dispatch(getFbrSnroTesting(data?.companyId));
      })
      .catch((error) => {
        dispatch(addFbrSnroTestingError(apiErrorMessage(error)));
        handleDangerVisible(apiErrorMessage(error));
      });
  };
};

// Getting FbrSnroTesting List
export const getFbrSnroTestingRequest = () => {
  return {
    type: "FBR_SNRO_TESTING_LIST_REQUEST",
  };
};
export const getFbrSnroTestingSuccess = (data) => {
  return {
    type: "FBR_SNRO_TESTING_LIST_SUCCESS",
    payload: data,
  };
};
export const getFbrSnroTestingError = (msg) => {
  return {
    type: "FBR_SNRO_TESTING_LIST_ERROR",
    payload: msg,
  };
};
export const getFbrSnroTesting = (id) => {
  return (dispatch) => {
    dispatch(getFbrSnroTestingRequest());
    API.get(
      `/scenario/get-scenarios-status/${id}`,
    )
      .then((res) => {
        let fbrSnroList = res.data;
        dispatch(getFbrSnroTestingSuccess(fbrSnroList));
      })
      .catch((error) => {
        dispatch(getFbrSnroTestingError(apiErrorMessage(error)));
      });
  };
};

// Updating FbrSnroTesting
export const updateFbrSnroTestingRequest = () => {
  return {
    type: "UPDATE_FBR_SNRO_TESTING_LIST_REQUEST",
  };
};
export const updateFbrSnroTestingSuccess = (data) => {
  return {
    type: "UPDATE_FBR_SNRO_TESTING_LIST_SUCCESS",
    payload: data,
  };
};
export const updateFbrSnroTestingError = (msg) => {
  return {
    type: "UPDATE_FBR_SNRO_TESTING_LIST_ERROR",
    payload: msg,
  };
};
export const updateFbrSnroTesting = (
  id,
  data,
  handleVisible,
  handleDangerVisible,
  navigate,
) => {
  return (dispatch) => {
    dispatch(updateFbrSnroTestingRequest());
    API.put(`/buyer/update-buyer/${id}`, data)
      .then((res) => {
        let updateFbrSnroTestingList = res.data;
        dispatch(updateFbrSnroTestingSuccess(updateFbrSnroTestingList));
        handleVisible(res.data.message, () =>
          navigate("/main/view-buyer-list"),
        );
      })
      .catch((error) => {
        dispatch(updateFbrSnroTestingError(apiErrorMessage(error)));
        handleDangerVisible(apiErrorMessage(error));
      });
  };
};

// Deleting FbrSnroTesting
export const deleteFbrSnroTestingRequest = () => {
  return {
    type: "DELETE_FBR_SNRO_TESTING_LIST_REQUEST",
  };
};
export const deleteFbrSnroTestingSuccess = (data) => {
  return {
    type: "DELETE_FBR_SNRO_TESTING_LIST_SUCCESS",
    payload: data,
  };
};
export const deleteFbrSnroTestingError = (msg) => {
  return {
    type: "DELETE_FBR_SNRO_TESTING_LIST_ERROR",
    payload: msg,
  };
};
export const deleteFbrSnroTesting = (
  id,
  handleVisible,
  handleDangerVisible,
  page,
  limit,
  searchTerm,
) => {
  return (dispatch) => {
    dispatch(deleteFbrSnroTestingRequest());
    API.delete(`/buyer/delete-buyer/${id}`)
      .then((res) => {
        let deleteFbrSnroTestingList = res.data;
        dispatch(deleteFbrSnroTestingSuccess(deleteFbrSnroTestingList));
        handleVisible(res.data.message);
        dispatch(getFbrSnroTesting(page, limit, searchTerm));
      })
      .catch((error) => {
        dispatch(deleteFbrSnroTestingError(apiErrorMessage(error)));
        handleDangerVisible(apiErrorMessage(error));
      });
  };
};
